export default class NBAFileEntity {
  constructor() {
    this.textHeader = null;
    this.textSubHeader = null;
    this.textValueParts = null;
    this.textInstruction = null;
    this.textTnC = null;
  }
}
